// extracted by mini-css-extract-plugin
module.exports = {"ALink":"LinkTag_ALink__TvU4U","About":"LinkTag_About__DTlOc"};